<template>
  <div 
    v-if="show" 
    class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-40 modal-backdrop"
  >
    <div class="bg-gray-900 rounded-lg p-6 max-w-2xl w-full mx-4 max-h-96 overflow-y-auto border border-gray-700 dark-card">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-2xl font-bold text-white">Impostazioni</h2>
        <button 
          @click="$emit('close')" 
          class="text-gray-400 hover:text-white text-2xl btn-secondary"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Phase Durations -->
      <div class="mb-6">
        <h3 class="text-lg font-semibold text-white mb-3">Durata Fasi (minuti)</h3>
        <div class="grid grid-cols-1 gap-3">
          <div>
            <label class="block text-sm text-gray-300 mb-1">Deadline</label>
            <input 
              v-model.number="settings.deadlineDuration" 
              type="number" 
              min="1" 
              max="30" 
              class="w-full p-2 bg-gray-800 border border-gray-600 rounded text-white focus:border-blue-500"
            >
          </div>
          <div>
            <label class="block text-sm text-gray-300 mb-1">Aggiornamento Progetti</label>
            <input 
              v-model.number="settings.projectDuration" 
              type="number" 
              min="1" 
              max="60" 
              class="w-full p-2 bg-gray-800 border border-gray-600 rounded text-white focus:border-blue-500"
            >
          </div>
          <div>
            <label class="block text-sm text-gray-300 mb-1">Aggiornamento Personale (per persona)</label>
            <input 
              v-model.number="settings.personalDuration" 
              type="number" 
              min="1" 
              max="10" 
              class="w-full p-2 bg-gray-800 border border-gray-600 rounded text-white focus:border-blue-500"
            >
          </div>
        </div>
      </div>

      <!-- Team Members -->
      <div class="mb-6">
        <div class="flex justify-between items-center mb-3">
          <h3 class="text-lg font-semibold text-white">Membri del Team</h3>
          <div class="flex items-center gap-2">
            <label class="text-sm text-gray-300">Ordine casuale</label>
            <input 
              v-model="settings.randomOrder" 
              type="checkbox" 
              class="w-4 h-4 bg-gray-800 border border-gray-600 rounded"
            >
          </div>
        </div>
        <div class="space-y-2 max-h-40 overflow-y-auto settings-scroll">
          <div 
            v-for="(member, index) in settings.teamMembers" 
            :key="index" 
            class="flex items-center gap-2"
          >
            <input 
              v-model="settings.teamMembers[index]" 
              type="text" 
              class="flex-1 p-2 bg-gray-800 border border-gray-600 rounded text-white focus:border-blue-500"
              :placeholder="'Membro ' + (index + 1)"
            >
            <button 
              @click="$emit('remove-member', index)" 
              class="p-2 text-red-400 hover:text-red-300 btn-secondary"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
          <button 
            @click="$emit('add-member')" 
            class="w-full p-2 border-2 border-dashed border-gray-600 rounded text-gray-400 hover:text-gray-300 hover:border-gray-500 btn-secondary"
          >
            <i class="fas fa-plus mr-2"></i>Aggiungi Membro
          </button>
        </div>
      </div>

      <!-- Save Button -->
      <div class="text-center">
        <button 
          @click="$emit('save')" 
          class="px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white font-bold rounded-lg btn-primary"
        >
          <i class="fas fa-save mr-2"></i>Salva Impostazioni
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      required: true
    }
  },
  emits: ['close', 'save', 'add-member', 'remove-member']
};
</script>